import type { User } from "api-types/modelTypes";
import { type ClientUser } from "api-types/users/usersResponses";

export default function getUserFullName(user: Partial<ClientUser> | null): string {
  if (!user) {
    return "";
  }

  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user.firstName) {
    return user.firstName;
  }

  return "";
}

export function constructUserName(name: string): Pick<User, "firstName" | "lastName"> {
  const spaceIndex = name.lastIndexOf(" ");
  const firstName = name.substring(0, spaceIndex);
  const lastName = name.substring(spaceIndex + 1);
  return { firstName, lastName };
}
